import type { SortValue } from '@components';

type SortMap = Partial<Record<string, string>>;

export const buildSortRequest = (
    sort: SortValue | null,
    sortMap: SortMap,
): { sortBy: string | null; sortOrder: 'ascending' | 'descending' | null } => {
    const sortBy = sort?.columnId ? (sortMap[String(sort.columnId)] ?? null) : null;
    const sortOrder = sort?.order === 'desc' ? 'descending' : sort?.order === 'asc' ? 'ascending' : null;
    return { sortBy, sortOrder };
};
